import initialState from './initialState';
import { reducer as dismissAllNotificationsReducer } from './dismissAllNotifications';
import { reducer as dismissNotificationReducer } from './dismissNotification';
import { LOGOUT_USER } from '../../common/redux/constants'
import { reducer as setCurrentLeadReducer } from './setCurrentLead';
import { reducer as clearCurrentLeadReducer } from './clearCurrentLead';
import { reducer as verifyAccountReducer } from './verifyAccount';
import { reducer as restorePaswordReducer } from './validateRestorePassword';
import { reducer as clearVerifyAccountReducer } from './clearVerifyAccount';
import { reducer as saveNotificationsReducer } from './saveNotifications';

const reducers = [
  dismissAllNotificationsReducer,
  dismissNotificationReducer,
  setCurrentLeadReducer,
  clearCurrentLeadReducer,
  verifyAccountReducer,
  restorePaswordReducer,
  clearVerifyAccountReducer,
  saveNotificationsReducer
];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    // Handle cross-topic actions here
    case LOGOUT_USER:
      newState = initialState;
      break;
    default:
      newState = state;
      break;
  }
  /* istanbul ignore next */
  return reducers.reduce((s, r) => r(s, action), newState);
}
